export const DIALOG_MARGIN = 32; //material dialog margins
export const DEFAULT_SIZES = 400;
export const DEFAULT_MIN_SIZES = 75;
